import { createContext } from "react";

const PurchasedLeaveWindowContext = createContext({ windowOpen: false, pxWindowOpen: false });

export default PurchasedLeaveWindowContext;
